// Reference admin: on a two-runner book each runner's figure is followed by a
// small dark badge — the size of that runner's book against the other one's.
// Checked on the reference (2026-09-29): punter backs South Australia W
// 100 @ 40 on a 10% panel → Victoria W 10 [2.5%], South Australia W -4 [0.4%],
// i.e. 10 / 4 and 4 / 10. Nothing is shown while either side is 0, nor on a
// market with a third runner (not seen on the reference yet).

export function bookRatios(books = []) {
  if (books.length !== 2) return books.map(() => null)
  const [a, b] = books.map((v) => Math.abs(Number(v) || 0))
  if (!a || !b) return [null, null]
  const fmt = (x) => `${parseFloat(x.toFixed(2))}%`
  return [fmt(a / b), fmt(b / a)]
}

export function BookRatio({ value }) {
  if (!value) return null
  return <span className="book-ratio">{value}</span>
}
